export function formattedDuration(duration) {
  if (duration < 10) {
    return `0${duration}`;
  }

  return duration;
}

function getHours(duration) {
  return Math.floor(duration / 1000 / 60 / 60);
}

function getMinutes(duration) {
  return Math.floor((duration / 1000 / 60) % 60);
}

function getSeconds(duration) {
  return Math.floor((duration / 1000) % 60);
}

function getMilliseconds(duration) {
  return Math.floor((duration % 1000) / 10);
}

function parseDuration(duration) {
  return {
    hours: getHours(duration),
    minutes: getMinutes(duration),
    seconds: getSeconds(duration),
    milliseconds: getMilliseconds(duration)
  };
}

export function formatDuration(duration = 0, short) {
  const { hours, minutes, seconds} = parseDuration(duration);

  if (short && hours) {
    return `${hours}:${formattedDuration(minutes)}`;
  }
  if (short && minutes) {
    return `${formattedDuration(minutes)}:${formattedDuration(seconds)}`;
  }

  if (hours) {
    return `${hours}:${formattedDuration(minutes)}:${formattedDuration(
      seconds
    )}`;
  }

  if (minutes) {
    return `${formattedDuration(minutes)}:${formattedDuration(
      seconds
    )}`;
  }

  return `${formattedDuration(minutes)}:${formattedDuration(seconds)}`;
}

export default {
  formatDuration
};
